import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useDisplay from "../../hooks/useDisplay";
import styled from "styled-components";
import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "./../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import LSRgH2HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import LSRgBody01 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import LSBdDisplay02 from "./../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import MainBtn from "./../../components/atoms/button/mainBtn";
import LSBdH1HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH1HeadLine";
import SelectBox from "../../components/organisms/SelectBox";
import InputField from "../../components/atoms/input/inputField";
import LSBdBody01 from "../../components/molecules/text/linSeedKr/Bd/lsBdBody01";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";
import MOContainer from "../../components/atoms/layout/moContainer";
import ReviewApi from "../../api/review.api";
import LectureApi from "../../api/lecture.api";
import { fileUrl } from "../../api/api";
import moment from "moment";
import { toast } from "react-toastify";
import { formatNumberWithCommas } from "../../util/formatNumber";
import { macOSCheck } from "../../util/macOSCheck";
import { errorHandler } from "../../util/errorHandler";
import Loading from "../../components/templates/loading";
import { route } from "../../router/route";

const MyPageClassroomReview = () => {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;
  const { memberLectureId, id } = useParams();
  const [isLoading, setIsLoading] = useState(true);

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("로그인이 필요한 서비스입니다.");
      navigate(
        `${route.login}?returnUrl=${encodeURIComponent(
          `${route.my_page_classroom_review}/${memberLectureId}/${id}`,
        )}`,
        { replace: true },
      );
      return;
    }

    if (
      !Number.isInteger(Number(memberLectureId)) ||
      Number(memberLectureId) <= 0 ||
      !Number.isInteger(Number(id)) ||
      Number(id) <= 0
    ) {
      navigate(route.my_page_classroom, { replace: true });
      return;
    }

    getLectureData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 강의 데이터 가져오기 ---------- //
  const [lectureData, setLectureData] = useState({});
  const [isConsulting, setIsConsulting] = useState(false);

  const getLectureData = async () => {
    try {
      const response = (await LectureApi.getMemberDetail(memberLectureId)).data
        .data.content;

      if (Number(response?.lecture?.id) !== Number(id)) {
        toast("올바른 상품 정보가 아닙니다.");
        navigate(route.my_page_classroom, { replace: true });
        return;
      }

      if (response?.reviewFlag) {
        toast("이미 후기를 작성한 상품입니다.");
        navigate(route.my_page_activity_review, { replace: true });
        return;
      }

      setLectureData(response?.lecture ?? {});
      setIsConsulting(!response?.lectureVideoFlag);
    } catch (error) {
      errorHandler(error);
      navigate(route.my_page_classroom, { replace: true });
    } finally {
      setIsLoading(false);
    }
  };

  // ---------- 리뷰 점수 관련 ---------- //
  const [inputValue, setInputValue] = useState({
    title: "",
    content: "",
  });

  const [reviewRatingBoxOpen, setReviewRatingBoxOpen] = useState(false);
  const [selectedReviewRating, setSelectedReviewRating] = useState("별점");

  const reviewRatingList = [
    { title: "1점", value: "1점" },
    { title: "2점", value: "2점" },
    { title: "3점", value: "3점" },
    { title: "4점", value: "4점" },
    { title: "5점", value: "5점" },
  ];

  // ---------- 리뷰 작성하기 ---------- //
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleReviewCreate = async () => {
    if (isSubmitting) return;

    try {
      const title = inputValue.title.trim();
      const content = inputValue.content.trim();

      if (!title) {
        toast("제목을 입력해 주세요.");
        return;
      }
      if (!content) {
        toast("내용을 입력해 주세요.");
        return;
      }
      if (selectedReviewRating === "별점") {
        toast("별점을 선택해 주세요.");
        return;
      }

      setIsSubmitting(true);
      const data = {
        memberLectureId: Number(memberLectureId),
        score: 0,
        title,
        content,
      };

      if (selectedReviewRating === "1점") {
        data.score = 1;
      } else if (selectedReviewRating === "2점") {
        data.score = 2;
      } else if (selectedReviewRating === "3점") {
        data.score = 3;
      } else if (selectedReviewRating === "4점") {
        data.score = 4;
      } else if (selectedReviewRating === "5점") {
        data.score = 5;
      }

      await ReviewApi.create(data);
      toast("후기가 작성되었습니다.");
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) return <Loading />;

  const productLabel = isConsulting ? "컨설팅" : "강의";

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
            padding: isSmall ? "0px 20px" : "0px",
          }}
        >
          <HeaderContainer>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 4,
              }}
            >
              <LSRgDisplay02 style={{ color: "#000" }}>
                {productLabel}는 어떠셨나요?
              </LSRgDisplay02>
              <LSRgH2HeadLine style={{ color: "#000" }}>
                {productLabel}에 대한 후기를 남겨주세요!
                <br />
                이용 정책에 어긋나는 후기는 삭제 처리될 수 있어요.
              </LSRgH2HeadLine>
            </div>
            <div
              style={{
                display: "flex",
                gap: 10,
                marginTop: 6.5,
              }}
            >
              <MainBtn
                disabled={isSubmitting}
                style={{
                  background: "#fff",
                  height: 36,
                  width: 72,
                }}
                onClick={() => {
                  navigate(-1);
                }}
              >
                <LSRgBody01
                  style={{
                    color: "#A4A8B1",
                    textAlign: "center",
                    marginTop: macOSCheck() ? 0 : 2,
                  }}
                >
                  취소
                </LSRgBody01>
              </MainBtn>
              <MainBtn
                disabled={isSubmitting}
                style={{
                  height: 36,
                  width: 72,
                }}
                onClick={() => {
                  handleReviewCreate();
                }}
              >
                <LSRgBody01
                  style={{
                    color: "#fff",
                    textAlign: "center",
                    marginTop: macOSCheck() ? 0 : 2,
                  }}
                >
                  {isSubmitting ? "등록 중..." : "등록"}
                </LSRgBody01>
              </MainBtn>
            </div>
          </HeaderContainer>

          {/* 본문 영역 */}
          <BodyContainer>
            {/* 본문 영역 - 강의 정보 */}
            <LectureContainer>
              <LectureContentImg
                src={
                  lectureData?.thumbnailServerFileName
                    ? `${fileUrl}/${lectureData?.thumbnailServerFileName}`
                    : ""
                }
                alt="콘텐츠 썸네일"
              />
              <LectureContentWrapper>
                <LSBdDisplay02 style={{ color: "#000" }}>
                  {lectureData?.title || ""}
                </LSBdDisplay02>
                <LectureContentTextContainer>
                  {isConsulting ? null : (
                    <>
                      <LectureContentTextWrapper>
                        <LSBdH1HeadLine style={{ color: "#898E99" }}>
                          수강기간
                        </LSBdH1HeadLine>
                        <LSRgH1HeadLine stye={{ color: "#000" }}>
                          {lectureData?.limitFlag
                            ? "무제한"
                            : `${formatNumberWithCommas(
                                lectureData?.period,
                              )}일`}
                        </LSRgH1HeadLine>
                      </LectureContentTextWrapper>
                      <LectureContentTextWrapper>
                        <LSBdH1HeadLine style={{ color: "#898E99" }}>
                          커리큘럼
                        </LSBdH1HeadLine>
                        <LSRgH1HeadLine stye={{ color: "#000" }}>
                          총 {lectureData?.curriculumCount || 0}강
                        </LSRgH1HeadLine>
                      </LectureContentTextWrapper>
                    </>
                  )}

                  <LectureContentTextWrapper>
                    <LSBdH1HeadLine
                      style={{
                        color: "#898E99",
                        letterSpacing: 6,
                        width: 55,
                      }}
                    >
                      강사명
                    </LSBdH1HeadLine>
                    <LSRgH1HeadLine stye={{ color: "#000" }}>
                      {lectureData?.instructorName || ""}
                    </LSRgH1HeadLine>
                  </LectureContentTextWrapper>
                </LectureContentTextContainer>
              </LectureContentWrapper>
            </LectureContainer>

            {/* 본문 영역 - 별점 및 제목 입력 */}
            <div
              style={{
                width: "100%",
                height: "fit-content",
                display: "flex",
                alignItems: "center",
                gap: 20,
              }}
            >
              <SelectBox
                isSmall={true}
                selectedValue={selectedReviewRating}
                isOpen={reviewRatingBoxOpen}
                wrapperHandler={() => {
                  setReviewRatingBoxOpen(!reviewRatingBoxOpen);
                }}
                itemList={reviewRatingList}
                selectedValueSetterFunc={setSelectedReviewRating}
              />
              <InputField
                id="title"
                name="title"
                placeholder="후기 제목을 입력해 주세요."
                type="text"
                autoComplete="off"
                value={inputValue.title}
                onChange={(e) => {
                  setInputValue({
                    ...inputValue,
                    title: e.target.value,
                  });
                }}
                containerStyle={{
                  width: 1005,
                }}
              />
            </div>

            {/* 본문 영역 - 내용 입력 */}
            <Textarea
              name="content"
              placeholder="후기를 입력해 주세요."
              value={inputValue?.content || ""}
              onChange={(e) => {
                setInputValue({
                  ...inputValue,
                  content: e.target.value,
                });
              }}
            />
          </BodyContainer>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <MOContainer>
          <ContentContainer $isSmall={isSmall}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 4,
                marginBottom: 20,
              }}
            >
              <LSRgH1HeadLine style={{ color: "#000" }}>
                {productLabel}는 어떠셨나요?
              </LSRgH1HeadLine>
              <LSRgCaption02 style={{ color: "#898e99" }}>
                {productLabel}에 대한 후기를 남겨주세요!
                <br />
                이용 정책에 어긋나는 후기는 삭제 처리될 수 있어요.
              </LSRgCaption02>
            </div>

            {/* 본문 영역 - 별점 및 제목 입력 */}
            <div
              style={{
                width: "100%",
                height: "fit-content",
                display: "flex",
                flexDirection: "column",
                gap: 16,
              }}
            >
              <SelectBox
                isSmall={true}
                style={{
                  width: 158,
                }}
                subMenuStyle={{
                  width: 158,
                }}
                selectedValue={selectedReviewRating}
                isOpen={reviewRatingBoxOpen}
                wrapperHandler={() => {
                  setReviewRatingBoxOpen(!reviewRatingBoxOpen);
                }}
                itemList={reviewRatingList}
                selectedValueSetterFunc={setSelectedReviewRating}
              />

              <InputField
                isSmall={true}
                id="title"
                name="title"
                placeholder="후기 제목을 입력해 주세요."
                type="text"
                autoComplete="off"
                value={inputValue.title}
                onChange={(e) => {
                  setInputValue({
                    ...inputValue,
                    title: e.target.value,
                  });
                }}
              />
              {/* 본문 영역 - 내용 입력 */}
              <Textarea
                name="content"
                placeholder="후기를 입력해 주세요."
                value={inputValue?.content || ""}
                onChange={(e) => {
                  setInputValue({
                    ...inputValue,
                    content: e.target.value,
                  });
                }}
              />

              <div
                style={{
                  display: "flex",
                  gap: 10,
                }}
              >
                <MainBtn
                  disabled={isSubmitting}
                  style={{
                    background: "#f6f7f8",
                    width: 164,
                    height: 46,
                  }}
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <LSRgBody01
                    style={{
                      color: "#A4A8B1",
                      textAlign: "center",
                    }}
                  >
                    취소
                  </LSRgBody01>
                </MainBtn>
                <MainBtn
                  disabled={isSubmitting}
                  style={{
                    width: 164,
                    height: 46,
                  }}
                  onClick={() => {
                    handleReviewCreate();
                  }}
                >
                  <LSRgBody01
                    style={{
                      color: "#fff",
                      textAlign: "center",
                    }}
                  >
                    {isSubmitting ? "등록 중..." : "등록"}
                  </LSRgBody01>
                </MainBtn>
              </div>
            </div>

            {/* 본문 영역 - 강의 정보 */}
            <LectureContainer $isSmall={isSmall} style={{ marginTop: 16 }}>
              <LectureContentImg
                $isSmall={isSmall}
                src={
                  lectureData?.thumbnailServerFileName
                    ? `${fileUrl}/${lectureData?.thumbnailServerFileName}`
                    : ""
                }
                alt="콘텐츠 썸네일"
              />
              <LectureContentWrapper $isSmall={isSmall}>
                <LSBdH1HeadLine> {lectureData?.title || ""}</LSBdH1HeadLine>
                <LectureContentTextContainer $isSmall={isSmall}>
                  {isConsulting ? null : (
                    <>
                      <LectureContentTextWrapper>
                        <LSBdBody01 style={{ color: "#898E99" }}>
                          수강기간
                        </LSBdBody01>
                        <LSRgH1HeadLine>
                          {lectureData?.limitFlag
                            ? "무제한"
                            : `${formatNumberWithCommas(
                                lectureData?.period,
                              )}일`}
                        </LSRgH1HeadLine>
                      </LectureContentTextWrapper>
                      <LectureContentTextWrapper>
                        <LSBdBody01 style={{ color: "#898E99" }}>
                          커리큘럼
                        </LSBdBody01>
                        <LSRgH1HeadLine>
                          총 {lectureData?.curriculumCount || 0}강
                        </LSRgH1HeadLine>
                      </LectureContentTextWrapper>
                    </>
                  )}

                  <LectureContentTextWrapper>
                    <LSBdBody01
                      style={{
                        color: "#898E99",
                        letterSpacing: 6,
                        width: 50,
                      }}
                    >
                      강사명
                    </LSBdBody01>
                    <LSRgH1HeadLine>
                      {" "}
                      {lectureData?.instructorName || ""}
                    </LSRgH1HeadLine>
                  </LectureContentTextWrapper>
                </LectureContentTextContainer>
              </LectureContentWrapper>
            </LectureContainer>
          </ContentContainer>
        </MOContainer>
      )}
    </HomeSection>
  );
};

export default MyPageClassroomReview;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: ${(props) =>
    props.$isSmall ? "" : "rgba(237, 237, 255, 0.5)"};
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const HeaderContainer = styled.div.attrs((props) => {})`
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;
`;

const BodyContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  width: 1200px;
  height: fit-content;
  gap: 20px;
`;

const LectureContainer = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  border-radius: 20px;
  padding: ${(props) => (props.$isSmall ? "20px" : "40px")};
  display: flex;
  flex-direction: ${(props) => (props.$isSmall ? "column" : "row")};
  gap: ${(props) => (props.$isSmall ? "20px" : "30px")};
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
`;

const LectureContentImg = styled.img.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "295px" : "278px")};
  height: ${(props) => (props.$isSmall ? "187px" : "177px")};
  object-fit: cover;
  border-radius: 15px;
`;

const LectureContentWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$isSmall ? "10px" : "30px;")};
`;

const LectureContentTextContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$isSmall ? "4px" : "8px")};
`;

const LectureContentTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 18px;
  width: 100%;
  height: 22px;
`;

const Textarea = styled.textarea.attrs((props) => {})`
  width: 100%;
  height: 700px;
  padding: 17px 15px;
  background-color: #fff;
  border: 1px solid #dbdde0;
  border-radius: 15px;
  resize: none;

  font-family: "LINESeedKR-Rg";
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  display: block;
  word-break: keep-all;
  white-space: pre-wrap;
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  letter-spacing: -0.6px;
  color: #000;

  &::placeholder {
    color: #a4a8b1;
  }

  &:focus {
    outline: none;
  }
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
  display: flex;
  flex-direction: column;
`;
